/**
 * Recently Viewed Vanilla Carousel
 * Replaces Slick carousel with vanilla JavaScript implementation
 */

window.RecentlyViewedCarousel = {
  initialize: function(grid) {
    if (!grid || grid.children.length === 0) {
      console.warn('⚠️ No products to show in recently viewed');
      return;
    }

    // Remove any existing carousel classes from grid
    grid.classList.remove('carousel-container', 'carousel-initialized');
    
    // Clear any existing carousel structure
    const existingTrack = grid.querySelector('.carousel-track');
    if (existingTrack) {
      // Move items back to grid
      while (existingTrack.firstChild) {
        grid.appendChild(existingTrack.firstChild);
      }
      existingTrack.remove();
    }
    
    // Remove existing carousel container and arrows
    const existingCarouselContainer = grid.parentElement.querySelector('.carousel-container');
    if (existingCarouselContainer) {
      // Move items back to grid before removing container
      const existingItems = existingCarouselContainer.querySelectorAll('.carousel-slide');
      existingItems.forEach(slide => {
        if (slide.firstChild) {
          grid.appendChild(slide.firstChild);
        }
      });
      existingCarouselContainer.remove();
    }
    
    // Get all product cards
    const items = Array.from(grid.children);
    if (items.length === 0) return;
    
    console.log('🎠 Initializing vanilla carousel with', items.length, 'items');
    
    // Create new carousel container div inside the grid
    const carouselContainer = document.createElement('div');
    carouselContainer.className = 'carousel-container carousel-initialized';
    
    // Add carousel container inside the grid
    grid.appendChild(carouselContainer);
    
    // Create carousel structure
    const track = document.createElement('div');
    track.className = 'carousel-track';
    
    // Wrap items in slides
    items.forEach((item, index) => {
      const slide = document.createElement('div');
      slide.className = 'carousel-slide';
      slide.appendChild(item);
      track.appendChild(slide);
    });
    
    // Add track to carousel container
    carouselContainer.appendChild(track);
    
    // Add navigation arrows outside the carousel container (in their previous position)
    const prevBtn = document.createElement('button');
    prevBtn.className = 'carousel-btn carousel-arrow carousel-prev';
    prevBtn.innerHTML = '<img loading="lazy" src="//cdn.shopify.com/s/files/1/0600/0659/6668/files/arrow-left.svg" alt="Previous" width="50" height="50" decoding="async">';
    prevBtn.setAttribute('aria-label', 'Previous products');
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'carousel-btn carousel-arrow carousel-next';
    nextBtn.innerHTML = '<img loading="lazy" src="//cdn.shopify.com/s/files/1/0600/0659/6668/files/arrow-right-alt.svg" alt="Next" width="50" height="50" decoding="async">';
    nextBtn.setAttribute('aria-label', 'Next products');
    
    // Add buttons inside the grid (after the carousel container)
    grid.appendChild(prevBtn);
    grid.appendChild(nextBtn);
    
    // Initialize carousel functionality
    this.initCarouselFunctionality(carouselContainer, track, items.length);
    
    console.log('✅ Recently viewed vanilla carousel initialized');
  },

  initCarouselFunctionality: function(container, track, totalItems) {
    let currentIndex = 0;
    let itemsPerView = this.getItemsPerView();
    
    const updateCarousel = () => {
      const slideWidth = 100 / itemsPerView;
      const translateX = -currentIndex * slideWidth;
      track.style.transform = `translateX(${translateX}%)`;
      
      // Update button states - buttons are now inside the grid
      const prevBtn = container.parentElement.querySelector('.carousel-prev');
      const nextBtn = container.parentElement.querySelector('.carousel-next');
      
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= totalItems - itemsPerView;
    };
    
    const nextSlide = () => {
      if (currentIndex < totalItems - itemsPerView) {
        currentIndex++;
        updateCarousel();
      }
    };
    
    const prevSlide = () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    };
    
    // Add event listeners - buttons are now inside the grid
    const nextBtn = container.parentElement.querySelector('.carousel-next');
    const prevBtn = container.parentElement.querySelector('.carousel-prev');
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        nextSlide();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        prevSlide();
      });
    }
    
    // Handle window resize
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newItemsPerView = this.getItemsPerView();
        if (newItemsPerView !== itemsPerView) {
          itemsPerView = newItemsPerView;
          // Adjust current index if needed
          if (currentIndex > totalItems - itemsPerView) {
            currentIndex = Math.max(0, totalItems - itemsPerView);
          }
          updateCarousel();
        }
      }, 250);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Touch/swipe support
    let startX = 0;
    let isDragging = false;
    
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });
    
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) { // Minimum swipe distance
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });
    
    // Mouse drag support for desktop
    let mouseStartX = 0;
    let isMouseDragging = false;
    
    track.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      isMouseDragging = true;
      track.style.cursor = 'grabbing';
    });
    
    track.addEventListener('mousemove', (e) => {
      if (!isMouseDragging) return;
      e.preventDefault();
    });
    
    track.addEventListener('mouseup', (e) => {
      if (!isMouseDragging) return;
      isMouseDragging = false;
      track.style.cursor = 'grab';
      
      const mouseEndX = e.clientX;
      const mouseDiff = mouseStartX - mouseEndX;
      
      if (Math.abs(mouseDiff) > 50) { // Minimum drag distance
        if (mouseDiff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });
    
    track.addEventListener('mouseleave', () => {
      isMouseDragging = false;
      track.style.cursor = 'grab';
    });
    
    // Initialize
    updateCarousel();
  },

  getItemsPerView: function() {
    const width = window.innerWidth;
    if (width <= 768) return 1.5; // Show 1.5 items on mobile
    if (width <= 992) return 2;   // Show 2 items on small tablet
    if (width <= 1024) return 3;  // Show 3 items on tablet
    if (width <= 1200) return 4;  // Show 4 items on large tablet
    return 5; // Show 5 items on desktop
  }
};
